import DOMPurify from 'dompurify'
import { marked } from 'marked'

export function sanitizeHtml(value) {
  return DOMPurify.sanitize(String(value ?? ''))
}

export function renderMarkdown(value) {
  return sanitizeHtml(marked.parse(String(value ?? '')))
}

export function joinHtmlItems(items = []) {
  if (!Array.isArray(items)) {
    return ''
  }

  return sanitizeHtml(items.map(item => item?.value ?? '').join(''))
}

export function preserveLineBreaks(value) {
  return sanitizeHtml(String(value ?? '').replace(/\n/g, '<br>'))
}
